<template lang="pug">
.mortgage-summary
    .monthly-cost.loan-result-row
        .loan-result-text 
          .text {{ $t('mortgage.monthlyCost') }}
          .subtitle {{ $t('mortgage.subtitle', { apr: formatPercentageToString(monthlyCost.apr / 100), berRating: monthlyCost.rating}) }}
        .loan-result-amount.amount-value {{ formatNumberToString(monthlyCost.cost) }}
    .monthly-cost.loan-result-row
        .loan-result-text 
          .text {{ $t('mortgage.energySavings') }}
        .loan-result-amount.amount-value.success — {{ formatNumberToString(energySavings) }}
    .monthly-cost.loan-result-row
        .loan-result-text 
          .text {{ $t('mortgage.savings') }}
          .subtitle {{ $t('mortgage.savingsSubtitle')}}
        .loan-result-amount.amount-value.success — {{ formatNumberToString(mortgageSavings) }}
    .monthly-cost.loan-result-row
        .loan-result-text 
          .text {{ $t('mortgage.monthlyNetCost') }}
        .loan-result-amount.amount-value {{ formatNumberToString(monthlyNetCost) }}
</template>
<script lang="ts">
interface MonthlyCost {
  apr: number;
  rating: string;
  cost: number;
}
import { defineComponent } from "vue";
import { PropType } from "vue";
import { formatPercentageToString, formatNumberToString } from "@/helpers";
export default defineComponent({
  name: "MortgageSummary",
  props: {
    monthlyCost: {
      type: Object as PropType<MonthlyCost>,
      required: true,
    },
    monthlyNetCost: {
      type: Number,
      required: true,
    },
    energySavings: {
      type: Number,
      required: true,
    },
    mortgageSavings: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      formatNumberToString,
      formatPercentageToString,
    };
  },
});
</script>
<style lang="scss">
.mortgage-summary {
  cursor: default;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  .loan-result-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.25rem;

    .amount-value {
      min-width: 3rem;
      text-align: end;
      &.success {
        color: $success-color;
      }
    }
  }
}
</style>
